export const StorageKey = "ftic_data";

export const TweetText =
  "cow. cow. cow Cow Cow COW COW! COW!! COW!!! 🐮 I just found a cow at FindTheInvisibleCow.com";
